import { ChangeDetectorRef, Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { Globals } from "@foh/globals";
import { ActivatedRoute } from "@angular/router";
import { ReservationformService } from "../reservationform/reservationform.service";
import { confirmWithHtml, manageListIssues, success, error } from "@foh/shared/data/sweet-alerts";
import * as utils from "@foh/shared/services/utils";
import * as alertFunctions from "@foh/shared/data/sweet-alerts"
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { confirm } from "@foh/shared/data/sweet-alerts";

@Component({
  selector: "app-manage-reservation",
  templateUrl: "./manage-reservation.component.html",
  styleUrls: ["./manage-reservation.component.scss"]
})
export class ManageReservationComponent implements OnInit {
  imageSrc: string = null;
  currentStep: string;
  fbscopeid: string;
  record: any = {};
  reservation: any = {};
  guests: any;
  branches: any;
  slots: any;
  routeObs$: any;
  reservationCode: string;
  startText: string = null;
  endText: string = null;
  hideEventButton = false;
  showGuestsList = false;
  showGuestlistEditStep = false;
  showBranchRow = false;
  showSlotEndTime = true;
  loading = false;
  loadingCancel = false;
  loadingPax = false;
  createCustomerAsGuest = false;
  formattedBranch: any;
  formattedSlot: any;
  formattedDate: any;
  isReadOnly = false;
  modeIsEdit = true;
  isTicketType = false;
  deletedGuestsIds: any = [];
  ticketPrices: any = [];
  fbGuestMandatory = false;
  emailGuestMandatory = false;
  mobileNumberAtGlMandatory = false;
  acceptInternationalNumbers = false;
  hideEditButton = false;
  isChangesSaved = false;
  currentSlot: any;
  originalReservation: any = {};
  excludedGL = false;
  maxPax
  maxPaxExceeded
  MESSAGES_TICKETSOLDOUT_TITLE: string = "Tickets are Sold out";
  MESSAGES_TICKETSOLDOUT_DESC: string =
    " can not purchase this ticket because it is sold out.";
  MESSAGES_TICKETINVALIDTYPE_TITLE: string =
    "Ticket Type is not compatible with Reservation type.";
  MESSAGES_TICKETINVALIDTYPE_DESC: string =
    " can not purchase this ticket type because it is not designed with the reservation type.(Seated/Standing)";

  constructor(
    private activeRoute: ActivatedRoute,
    private renderer: Renderer2,
    private globals: Globals,
    private reservationformService: ReservationformService,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef
  ) {
    this.guests = [];
    this.branches = [];
    this.slots = [];
  }

  ngOnInit() {
    //183127
    //makki45RWref
    this.reservation.customer_profile = {};
    this.reservation.customer_profile.main_profile = {};
    this.routeObs$ = this.activeRoute.params.subscribe(params => {
      this.reservationCode = params["refcode"];
      this.fbscopeid = params["fbid"];
      this.reservationformService
        .retrieveReservationDetails(params)
        .subscribe((response: any) => {
          if (typeof response.metaData.hideEditButton === "undefined") {
            this.hideEventButton = false;
          } else {
            this.hideEventButton = response.metaData.hideEditButton;
          }
          this.showSlotEndTime = response.metaData.showSlotEndTime;
          this.fbGuestMandatory = response.metaData.fbGuestMandatory;
          this.mobileNumberAtGlMandatory = response.metaData.mobileNumberAtGlMandatory;
          this.emailGuestMandatory = response.metaData.emailGuestMandatory;
          this.acceptInternationalNumbers = response.metaData.acceptInternationalNumbers;
          this.hideEditButton = response.metaData.hideEditButton;
          this.renderer.addClass(document.body, response.metaData.cssclass);
          this.imageSrc =
            this.globals.UPLOADS + "logos/" + response.metaData.logo;
          this.populateReservation(response.reservation, response.dic);
        });
    });
    // this.checkGlExcludedCategories();
  }

  populateReservation(reservation, dic) {
    this.originalReservation = JSON.parse(JSON.stringify(reservation));
    this.formattedBranch = "-";
    this.formattedSlot = "-";
    this.formattedDate = "-";
    this.reservation = reservation;
    this.slots = this.reservation.branch.slots;
    this.record.pax = this.reservation.requested_pax;
    this.record.typeid = "" + this.reservation.reservationtype_id;
    this.record.branch_id = this.reservation.branch_id;
    this.record.slot_id = this.reservation.slot_id;
    this.record.guest_comments = this.reservation.guest_comments;
    this.record.adminrequest_notes = this.reservation.adminrequest_notes;
    this.record.date = utils.formatDateSqlToCustomObject(this.reservation.date);
    this.formattedDate = utils.formatDateCustomObjectToSql(this.record.date);

    if (this.reservation.branch) {
      this.formattedBranch = this.reservation.branch.name
    }

    this.currentSlot = this.getSlotById(this.record.slot_id);
    this.checkGl(this.record.pax);

    if (this.currentSlot) {
      this.formattedSlot = utils.formatSlotNameForPublic(this.currentSlot, this.showSlotEndTime);
    } else {
      console.error('Slot not found!');
    }

    if ((this.currentSlot.guestlistmode || this.currentSlot.guestlistfbonly) && this.reservation.guest_lists.length < this.currentSlot.guest_list_pax) {
      const customerProfile = this.reservation.customer_profile;
      const mainProfile = customerProfile.main_profile;
      this.guests = [{
        email: customerProfile.email,
        fblink: customerProfile.fblink,
        fname: customerProfile.fname,
        lname: customerProfile.lname,
        gender: customerProfile.gender,
        host: 1,
        mobileno: mainProfile.mobileno
      }];
    } else if (this.reservation.guest_lists.length >= this.currentSlot.guest_list_pax) {
      this.guests = this.reservation.guest_lists;
    }

    if (this.reservation.ticketmodeon) {
      this.ticketPrices = this.currentSlot.ticketprices;
      var formattedGuests = this.formatTicketsList(
        this.reservation.ticketlists
      );
      this.guests = formattedGuests;
      if (this.guests.length > 0 && this.guests[0].host) {
        this.record.defaultticketcat = this.guests[0].ticketcat_id;
      }
    }
    this.checkReadOnlyStatus();
    this.addBranchToArray(reservation.branch);
  }


  getSlotById(id) {
    var found: any = false;
    if (id === null) {
      return found;
    }
    var slots = this.slots;
    for (var i = 0; i < slots.length; i++) {
      if (slots[i].id == id) {
        found = {};
        found = slots[i];
        break;
      }
    }
    return found;
  }

  checkGl(numberOfPeople) { // there was more condition with guestliston here
    if (this.currentSlot && ((this.currentSlot.guestlistmode || this.currentSlot.guestlistfbonly) && (numberOfPeople >= this.currentSlot.guest_list_pax))) {
      this.showGuestsList = true;
    } else {
      this.showGuestsList = false;
    }
    this.cdr.detectChanges();
  }

  // checkGlExcludedCategories() {
  //   if (this.currentSlot) {
  //     let body = {
  //       mobileNo: this.record.mobileno,
  //       slotId: this.currentSlot.id
  //     };
  //     this.reservationformService.checkGuestList(body).subscribe((response: any) => {
  //       this.excludedGL = response.skipGL;
  //       this.maxPax = response.maxPax;
  //       if (this.excludedGL) {
  //         this.showGuestsList = true;
  //       } else {
  //         this.showGuestsList = false;
  //       }
  //     });
  //   } else {
  //     console.error('Current slot is not defined!');
  //   }
  // }

  onGuestDelete(id) {
    this.deletedGuestsIds.push(id);
  }

  onCancelReservationBtnPress() {
    if (this.loadingCancel) {
      return;
    }
    confirmWithHtml(
      "",
      "Are you sure you want to cancel your reservation?"
    ).then(confirm => {
      if (confirm.value == true) {
        var params = { refcode: this.reservationCode };
        this.loadingCancel = true;
        this.reservationformService
          .cancelReservation(params)
          .subscribe((response: any) => {
            this.loadingCancel = false;
            if (response) {
              this.reservation.status = 5;
              this.reservation.canceled = 1;
              this.checkReadOnlyStatus();
            }
          },
            error => {
              this.loadingCancel = false;
            });
      }
    });
  }

  checkReadOnlyStatus() {
    if (this.reservation.status == 5 && this.reservation.canceled == 1) {
      this.isReadOnly = true;
      return;
    }
    if (this.reservation.status == 6 && this.reservation.requestapproved == 0) {
      this.isReadOnly = true;
      return;
    }
    if (this.reservation.totalpaiddeposit > 0) {
      this.isReadOnly = true;
      return;
    }
    this.isReadOnly = false;
  }

  confirmSubmit() {
    if (!this.validate()) {
      return;
    }
    if (this.loadingCancel) {
      return;
    }
    if (this.reservation.status == 6 && this.reservation.requestapproved != 0) {
      this.onSubmit2();
      return;
    }
    confirmWithHtml(
      "Edit Reservation Request",
      "Are you sure you want to edit your request? This action will reset your reservation status back to 'Pending'"
    ).then(confirm => {
      if (confirm.value == true) {
        this.onSubmit2();
      }
    });
  }

  onSubmit2() {
    var params = { ...this.record };
    params.refcode = this.reservationCode;
    params.requested_pax = this.record.pax;
    if (!utils.compareCustomDateWithSql(params.date, this.reservation.date)) {
      params.date = utils.formatDateCustomObjectToSql(params.date);
    } else {
      delete params.date;
    }
    if (params.slot_id == this.record.slot_id) {
      delete params.slot_id;
    }
    params.newguests = this.getNewGuestsList();
    params.editguests = this.getDirtyGuestsList();
    params.deletedguestsid = this.deletedGuestsIds;
    if (this.reservation.guestliston == 1) {
      delete params.requested_pax;
    }
    this.loadingPax = true;
    this.reservationformService.editReservation(params).subscribe(
      (response: any) => {
        this.loadingPax = false;
        this.isChangesSaved = true;
        this.showGuestlistEditStep = false;
        this.populateReservation(response.reservation, response.dic);
        if (
          typeof response["guestsListIssues"] !== "undefined" &&
          response["guestsListIssues"].length > 0
        ) {
          manageListIssues(
            "Reservation Request saved with issues",
            response["guestsListIssues"]
          );
        } else {
          success(
            "Reservation Request Saved",
            "We have recieved your reservation updates. We will contact you shorty."
          );
        }
      },
      error => {
        this.loadingPax = false;
        this.isChangesSaved = false;
      }
    );
  }

  onGuestListReset() {
    this.createCustomerAsGuest = true;
  }

  getNewGuestsList() {
    var array = [];
    for (var i = 0; i < this.guests.length; i++) {
      if (
        typeof this.guests[i]._dirty !== "undefined" &&
        this.guests[i]._dirty &&
        typeof this.guests[i].id === "undefined"
      ) {
        array.push(this.guests[i]);
      }
    }
    return array;
  }
  getDirtyGuestsList() {
    var array = [];
    for (var i = 0; i < this.guests.length; i++) {
      if (
        typeof this.guests[i]._dirty !== "undefined" &&
        this.guests[i]._dirty &&
        typeof this.guests[i].id !== "undefined"
      ) {
        array.push(this.guests[i]);
      }
    }
    return array;
  }

  formatTicketsList(ticketLists) {
    var array = [];
    for (var i = 0; i < ticketLists.length; i++) {
      array.push(utils.formatTicketCategoryForGuest(ticketLists[i], this.isTicketType, this.ticketPrices));
    }
    return array;
  }

  validate() {
    //Validate Basic Data

    // this.fieldsForm.recheckSlotGuestList();
    // this.showGuestsList = this.fieldsForm.showGuestsList;
    // this.guests = this.fieldsForm.guests;
    // this.recheckSlotGuestList();
    var basicData = this.validateHostData();
    if (!basicData) {
      return false;
    }

    //Validate Guestlist
    var guestlistData = this.validateGuestlist();

    return basicData && guestlistData;
  }

  validateHostData() {
    if (!this.isTicketType) {
      return true;
    }
    var ticketStatus = this.validateTicket(this.record.defaultticketcat);
    var genderRatioStatus = this.validateGenderRatio();
    var fullname = this.record.fname + " " + this.record.lname;
    if (ticketStatus == -1) {
      error(
        this.MESSAGES_TICKETSOLDOUT_TITLE,
        fullname + this.MESSAGES_TICKETSOLDOUT_DESC
      );
      return false;
    }
    if (ticketStatus == -2) {
      error(
        this.MESSAGES_TICKETINVALIDTYPE_TITLE,
        fullname + this.MESSAGES_TICKETINVALIDTYPE_DESC
      );
      return false;
    }
    if (genderRatioStatus == -1) {
      error(
        "Gender Ratio is invalid",
        "Number of females Guests must be equal or more than the number of male guests."
      );
      return false;
    }
    if (genderRatioStatus == -2) {
      error(
        "Gender Ratio is invalid",
        "Number of Females Guests must be exactly equal to the  number of male guests."
      );
      return false;
    }
    if (genderRatioStatus == -3) {
      error(
        "Gender Ratio is invalid",
        "Number of males Guests must be equal or more than the number of females guests."
      );
      return false;
    }
    return true;
  }

  isGuestFormComplete(guest) {
    return guest.fname && guest.lname &&
      (!this.mobileNumberAtGlMandatory || guest.mobileno) &&
      (!this.isTicketType || guest.ticketcat_id) &&
      (!this.emailGuestMandatory || guest.email) &&
      (!this.fbGuestMandatory || guest.fblink);
  }

  validateGuestlist() {
    if (!this.showGuestsList) {
      return true;
    }

    for (let guest of this.guests) {
      if (!this.isGuestFormComplete(guest)) {
        alertFunctions.error(
          "Guestlist Error",
          "The reservation guest list is incomplete. Please add all the guest in your party excluding yourself."
        );
        return false;
      }
    }

    var sizeToCompare = this.guests.length;
    if (sizeToCompare != this.record.pax) {
      //Size Error
      error(
        "Guestlist Error",
        "The reservation guest list is incomplete. Please add all the guest in your party excluding yourself."
      );
      return false;
    }

    var genderRatioStatus = this.validateGenderRatio();
    if (genderRatioStatus == -1) {
      alertFunctions.error(
        "Gender Ratio is invalid",
        "Number of females Guests must be equal or more than the number of male guests."
      );
      return false;
    }
    if (genderRatioStatus == -2) {
      alertFunctions.error(
        "Gender Ratio is invalid",
        "Number of Females Guests must be exactly equal to the number of male guests."
      );
      return false;
    }
    if (genderRatioStatus == -3) {
      alertFunctions.error(
        "Gender Ratio is invalid",
        "Number of males Guests must be equal or more than the number of females guests."
      );
      return false;
    }

    var arrayOfNames = [];
    var arrayOfMobiles = [];
    var arrayOfFbLinks = [];
    //Make Sure ALl Guestnames are unique.
    for (var i = 0; i < this.guests.length; i++) {
      var fullname = this.guests[i].fname + " " + this.guests[i].lname;
      var checkFullName = arrayOfNames.indexOf(fullname);
      if (checkFullName === -1) {
        arrayOfNames.push(fullname);
      } else {
        error(
          "Guestlist Error",
          "The Guestlist can not have repeating names/can not be the same name as the request host's name."
        );
        return false;
      }

      if (typeof this.guests[i].mobileno !== "undefined" && this.guests[i].mobileno != null && this.guests[i].mobileno != "") {
        var checkMobiles = arrayOfMobiles.indexOf(this.guests[i].mobileno);
        if (checkMobiles === -1) {
          arrayOfMobiles.push(this.guests[i].mobileno);
        } else {
          error(
            "Guestlist Error",
            "The Guestlist can not have repeating mobile numbers/can not be the same name as the request host's mobile number."
          );
          return false;
        }
      }

      //Checking Tickets Types(if Ticket mode)
      if (this.isTicketType) {
        var ticketStatus = this.validateTicket(this.guests[i].ticketcat_id);
        if (ticketStatus == -1) {
          error(
            this.MESSAGES_TICKETSOLDOUT_TITLE,
            fullname + this.MESSAGES_TICKETSOLDOUT_DESC
          );
          return false;
        }
        if (ticketStatus == -2) {
          error(
            this.MESSAGES_TICKETINVALIDTYPE_TITLE,
            fullname + this.MESSAGES_TICKETINVALIDTYPE_DESC
          );
          return false;
        }
      }
    }
    return true;
  }

  validateTicket(ticketId) {
    var ticketCategory = utils.getTicketCategoryById(ticketId, this.ticketPrices);
    if (ticketCategory.soldFlag) {
      return -1;
    }
    if (
      (ticketCategory.ttype == "2" && this.record.typeid != "1") ||
      (ticketCategory.ttype == "3" && this.record.typeid != "2")
    ) {
      return -2;
    }
    return true;
  }

  validateGenderRatio() {
    var selectedSlot = this.currentSlot;
    var ratioType = selectedSlot.genderratio;
    if (ratioType == null || ratioType == "0" || ratioType == 0) {
      return true;
    }
    var totalNumberOfMales = 0;
    var totalNumberOfFemales = 0;
    if (this.record.gender == "m") {
      totalNumberOfMales++;
    }
    if (this.record.gender == "f") {
      totalNumberOfFemales++;
    }
    for (var i = 0; i < this.guests.length; i++) {
      if (this.guests[i].host) {
        continue;//SKip Host Check at Manage Reservation only
      }
      if (this.guests[i].gender == "m") {
        totalNumberOfMales++;
      }
      if (this.guests[i].gender == "f") {
        totalNumberOfFemales++;
      }
    }
    switch (ratioType) {
      case "1":
      case 1:
        if (totalNumberOfFemales < totalNumberOfMales) {
          return -1;
        }
        break;
      case "2":
      case 2:
        if (totalNumberOfFemales !== totalNumberOfMales) {
          return -2;
        }
        break;
      case "3":
      case 3:
        if (totalNumberOfFemales > totalNumberOfMales) {
          return -3;
        }
        break;
    }
    return true;
  }

  injectTicketSoldCounts(dic) {
    var slotId = this.reservation.slot_id;
    var selectedSlot = this.currentSlot;
    for (
      var k = 0;
      k < selectedSlot.ticketprices.length;
      k++
    ) {
      selectedSlot.ticketprices[k].soldFlag =
        dic[selectedSlot.ticketprices[k].id];
    }
  }

  injectTicketPrices(selectedSlot) {
    this.ticketPrices = selectedSlot.ticketprices;
    if (this.ticketPrices.length > 0) {
      if (
        typeof this.record.defaultticketcat === "undefined" ||
        this.record.defaultticketcat == null
      ) {
        this.record.defaultticketcat = this.ticketPrices[0].id;
      }
      var ticketCategory = utils.getTicketCategoryById(this.record.defaultticketcat, this.ticketPrices);
      this.record.formattedTicketCategory = utils.formatTicketCategory(ticketCategory);
      if (ticketCategory.formattedValue.customdeadline) {
        this.record.formattedTicketDeadline = ticketCategory.formattedValue.deadline;
      }
    }
  }

  addBranchToArray(branch) {
    this.branches = [branch];
  }

  onEditGuestlistBtnPress() {
    this.showGuestlistEditStep = true;
  }

  onBackToMainFormBtnPress() {
    confirm(
      "Back without saving?",
      "Do you want to go back without saving?"
    ).then(confirm => {
      if (confirm.value == true) {
        // this.reservation = JSON.parse(JSON.stringify(this.originalReservation));
        this.populateReservation(this.reservation, null);
        this.showGuestlistEditStep = false;
      }
    });
  }
  onSaveGuestlistBtnPress() {
    this.confirmSubmit();
  }

  onNumberOfPeopleChange(numberOfPeople: number) {
    this.checkGl(numberOfPeople);
  }
}
